exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sessions {\n  margin-left: 1em;\n}\ndiv.detail-container-row {\n  margin: 15px 0;\n  min-height: 82px;\n  margin-left: 0;\n  border-bottom: 1px solid lightgray;\n}\ndiv.detail-container-row div.detail-container {\n  position: relative;\n}\ndiv.detail-container-row div.detail-container ::ng-deep .dropdown:first-of-type {\n  margin-top: -90px;\n}\ndiv.detail-container-row button.add {\n  background: #178ae0;\n  border-radius: 50px;\n  color: #FFF;\n  font-weight: normal;\n  border-bottom: none;\n  bottom: 0;\n  float: right;\n  margin-top: 1.8em;\n  padding: .5em .8em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program-with-sessions/program-with-sessions.component.less
// module id = ../../../../../src/app/dashboard/program-list/program-with-sessions/program-with-sessions.component.less
// module chunks = 2